/*
Copyright 2023 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

.search {
  border: 1px solid var(--cpd-color-border-interactive-secondary);
  border-radius: 9999px;
  block-size: 36px;
  box-sizing: border-box;
  color: var(--cpd-color-text-primary);
  display: flex;

  /* !important to override Field's default flex settings */
  flex-direction: row !important;
  gap: var(--cpd-space-2x) !important;
  align-items: center;
  padding: var(--cpd-space-1-5x) var(--cpd-space-3x);
}

@media (hover) {
  .search:hover {
    border-color: var(--cpd-color-border-interactive-hovered);
  }
}

.search:active {
  border-color: var(--cpd-color-border-interactive-hovered);
}

.search:focus-within {
  border-color: currentcolor;
}

.icon {
  color: var(--cpd-color-icon-secondary);
  flex-shrink: 0;
}

@media (hover) {
  .search:hover .icon {
    color: var(--cpd-color-icon-primary);
  }
}

.search:active .icon {
  color: var(--cpd-color-icon-primary);
}

.input {
  border: 0;
  background: inherit;
  outline: 0;
  flex: 1;
  min-inline-size: 0;
}

.input::placeholder {
  color: var(--cpd-color-text-secondary);
}

/* stylelint-disable-next-line defensive-css/require-focus-visible */
.input:focus::placeholder {
  color: var(--cpd-color-text-secondary);
}

@media (hover) {
  .search:hover .input::placeholder {
    color: var(--cpd-color-text-secondary);
  }
}
